module.exports = __webpack_public_path__ + "img/error.aca3abdb.svg";